import { ReactNode } from 'react';
import styled from 'styled-components';
import constants from '../constants';

export const PageContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    max-width: ${constants.sizes.container};
    width: calc(100% - 40px);
    margin: auto;
    margin-top: 230px;

    h2 {
        margin-bottom: 15px;
    }

    @media screen and (max-width: ${constants.breakpoints.miniTablet}) {
        margin-top: 50px;
    }
`;

export function Page({ children }: { children: ReactNode }) {
    return <div className="flex flex-col items-center w-[calc(100%-40px)] mx-auto">{children}</div>;
}
